// client/src/components/ResourceCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const ResourceCard = ({ resource, isTeaserOpen, onToggleTeaser }) => {
  return (
    <div className="bg-white rounded shadow-md overflow-hidden mb-4">
      {/* Image + overlay title */}
      <div className="relative h-32 sm:h-40">
        <img
          src={resource.image}
          alt={resource.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center p-2">
          <h3 className="text-white text-lg sm:text-xl lg:text-2xl text-center font-semibold px-2">
            {resource.title}
          </h3>
        </div>
      </div>

      {/* Teaser + buttons */}
      <div className="p-4">
        {isTeaserOpen ? (
          <p className="text-gray-700 mb-2">{resource.teaser}</p>
        ) : null}

        <div className="flex gap-4">
          <button
            onClick={onToggleTeaser}
            className="text-deep-navy font-semibold hover:text-warm-orange"
          >
            {isTeaserOpen ? 'Hide Teaser' : 'Show Teaser'}
          </button>

          <Link
            to={`/resource/${resource.slug}`}
            className="text-deep-navy font-semibold hover:text-warm-orange"
          >
            Read Full →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;
